import { render } from "./SelectDate.vue?vue&type=template&id=7ccd04c2"
import script from "./SelectDate.vue?vue&type=script&lang=js"
export * from "./SelectDate.vue?vue&type=script&lang=js"
script.render = render

export default script